import styled from "styled-components";

export const Container = styled.div`
  height: 150vh;

  @media (max-width: 768px) {
    height: 115vh;
  }

`;